import { React, useState, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { ArrowButton } from 'components/widgets/Buttons';
import axios from 'axios';
import { success } from 'assets/images';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

function PartnerWithUsIndividual() {
	const [open, setOpen] = useState(false);
	const menuRef = useRef();
	const buttonRef = useRef();

	window.addEventListener('click', (e) => {
		if (e.target !== menuRef.current && e.target !== buttonRef.current) {
			setOpen(false);
		}
	});
	const navigate = useNavigate();
	const phoneRegExp =
		/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
	const formik = useFormik({
		initialValues: {
			lastName: '',
			email: '',
			firstName: '',
			phoneNumber: '',
			about: '',
			interested: '',
			check: false,
		},
		validationSchema: Yup.object({
			about: Yup.string().oneOf(
				['LinkedIn', 'Social media', 'Friends', 'Referral', 'Others'],
				'Invalid Answer'
			),
			lastName: Yup.string()
				.min(3, 'Must be 3 characters or less')
				.required('Required'),
			firstName: Yup.string()
				.min(3, 'Must be 3 characters or less')
				.required('Required'),
			email: Yup.string().email('Invalid email address').required('Required'),
			phoneNumber: Yup.string().min(10).matches(phoneRegExp),
			interested: Yup.string().oneOf(
				['BWC write a Book Project', 'BWC Show', 'BWC Mentorship Program'],
				'Invalid Answer'
			),
			check: Yup.bool()
				.required('Required')
				.oneOf([true], 'Accept the terms and conditions'),
		}),
		onSubmit: () => {
			axios({
				method: 'POST',
				url: 'http://localhost:5000/api/auth/partnerwithusindividual',
				data: formik.values,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
				.then(function (response) {
					console.log(response);
					Swal.fire({
						imageUrl: success,
						imageWidth: 100,
						imageHeight: 100,
						imageAlt: 'Success',
						title: 'Submitted Successfully',
						text: 'You have successfully filled the Partner With Us as an Individual Form.',
						width: 600,
						color: '#fff',
						padding: '3em',
						background: '#000',
						confirmButtonColor: '#800080',
						backdrop: 'rgba(255,255,255,0.3)',
					});
					navigate('/');
				})
				.catch(function () {
					Swal.fire({
						imageUrl: success,
						imageWidth: 100,
						imageHeight: 100,
						imageAlt: 'Success',
						title: 'Submission was Unsuccessful',
						text: 'Kindly try again.',
						width: 600,
						color: '#fff',
						padding: '3em',
						background: '#000',
						confirmButtonColor: '#800080',
						backdrop: 'rgba(255,255,255,0.3)',
					});
				});
		},
	});
	return (
		<>
			<div className='bg-[#0E1022] py-8 md:py-8 lg:px-8 lg:py-8 xl:px-8 xl:py-8 2xl:px-8 2xl:py-8 mb-0'>
				<div>
					<h1 className='text-3xl md:text-4xl lg:text-4xl xl:text-4xl 2xl:text-4xl text-center text-transparent font-semibold bg-clip-text bg-gradient-to-r from-purple to-gold pb-6 pt-4'>
						Partner with us as an Individual
					</h1>
					<p className='text-base my-2 text-white text-center px-10 md:px-20 lg:px-20 xl:px-20 2xl:px-20 pb-4 2xl:text-center'>
						Thank you for your interest in partnering with us. Please fill out
						this form and we will reach out to you for more details.
					</p>
					<div className='grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 2xl:grid-cols-1 px-10 md:px-20 lg:px-20 xl:px-20 2xl:px-20 mb-4'>
						<label htmlFor='partner' className='text-white text-base'>
							Partner with us as
						</label>
						<div className='text-black bg-white w-full p-1 rounded'>
							<div className='flex justify-between'>
								<button
									ref={buttonRef}
									onClick={() => setOpen(!open)}
									className='text-sm'
								>
									--Select--
								</button>
								<ArrowButton />
							</div>
							{open && (
								<div ref={menuRef} className='mt-2'>
									<ul>
										<li onClick={() => setOpen(false)}>
											<Link
												to='/partner-with-us-individual'
												className='text-sm'
											>
												Individual
											</Link>
										</li>
										<li onClick={() => setOpen(false)}>
											{' '}
											<Link to='/partner-with-us-company' className='text-sm'>
												Company
											</Link>
										</li>
									</ul>
								</div>
							)}
						</div>
					</div>
				</div>
				<form onSubmit={formik.handleSubmit}>
					<div className='grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2'>
						<div className='px-10 md:px-20 lg:px-20 xl:px-20 2xl:px-20 mb-4'>
							<label htmlFor='firstName' className='text-white text-base'>
								First Name <b className='text-red text-base'>*</b>
							</label>
							<input
								name='firstName'
								type='text'
								className='w-full p-1 rounded text-sm'
								placeholder='Enter your First Name'
								onChange={formik.handleChange}
							/>
							{formik.touched.firstName && formik.errors.firstName ? (
								<div className='text-red text-base'>
									{formik.errors.firstName}
								</div>
							) : null}
						</div>
						<div className='px-10 md:px-20 lg:px-20 xl:px-20 2xl:px-20 mb-4'>
							<label htmlFor='lastName' className='text-white text-base'>
								Last Name <b className='text-red text-base'>*</b>
							</label>
							<input
								name='lastName'
								type='text'
								className='w-full p-1 rounded text-sm'
								placeholder='Enter your lastName'
								onChange={formik.handleChange}
							/>
							{formik.touched.lastName && formik.errors.lastName ? (
								<div className='text-red text-base'>
									{formik.errors.lastName}
								</div>
							) : null}
						</div>
					</div>

					<div className='grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2'>
						<div className='grid grid-cols-1 px-10 md:px-20 lg:px-20 xl:px-20 2xl:px-20 mb-4'>
							<label htmlFor='email' className='text-white text-base'>
								Email Address <b className='text-red text-base'>*</b>
							</label>
							<input
								name='email'
								type='email'
								className='p-1 rounded text-sm'
								placeholder='Enter your Email Address'
								onChange={formik.handleChange}
							/>
							{formik.touched.email && formik.errors.email ? (
								<div className='text-red text-base'>{formik.errors.email}</div>
							) : null}
						</div>
						<div className='px-10 md:px-20 lg:px-20 xl:px-20 2xl:px-20 mb-4'>
							<label htmlFor='phoneNumber' className='text-white text-base'>
								Phone Number
							</label>
							<input
								name='phoneNumber'
								type='tel'
								className='w-full p-1 rounded bg-white text-sm'
								placeholder='Enter your Phone Number'
								onChange={formik.handleChange}
							/>
							{formik.touched.phoneNumber && formik.errors.phoneNumber ? (
								<div className='text-red text-base'>
									{formik.errors.phoneNumber}
								</div>
							) : null}
						</div>
					</div>

					<div className='grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 2xl:grid-cols-1 px-10 md:px-20 lg:px-20 xl:px-20 2xl:px-20 mb-4'>
						<label htmlFor='about' className='text-white text-base'>
							How did you hear about us?
						</label>
						<select
							name='about'
							className='p-1 rounded text-sm'
							onChange={formik.handleChange}
						>
							<option>--Select--</option>
							<option value='LinkedIn'>LinkedIn</option>
							<option value='Social media'>Social media</option>
							<option value='Friends'>Friends</option>
							<option value='Referral'>Referral</option>
							<option value='Others'>Others</option>
						</select>
						{formik.touched.about && formik.errors.about ? (
							<div className='text-red text-base'>{formik.errors.about}</div>
						) : null}
					</div>

					<div className='grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 2xl:grid-cols-1 px-10 md:px-20 lg:px-20 xl:px-20 2xl:px-20 mb-4'>
						<label htmlFor='interested' className='text-white text-base'>
							Which of these initiatives are you interested in?
						</label>
						<select
							name='interested'
							className='p-1 rounded text-sm'
							onChange={formik.handleChange}
						>
							<option>--Select--</option>
							<option value='BWC write a Book Project'>
								BWC write a Book Project
							</option>
							<option value='BWC Show'>BWC Show</option>
							<option value='BWC Mentorship Program'>
								BWC Mentorship Program
							</option>
						</select>
						{formik.touched.interested && formik.errors.interested ? (
							<div className='text-red text-base'>
								{formik.errors.interested}
							</div>
						) : null}
					</div>

					<div className='grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 2xl:grid-cols-1 px-10 md:px-20 lg:px-20 xl:px-20 2xl:px-20 mb-4'>
						<label htmlFor='check' className='text-white text-base'>
							<input
								type='checkbox'
								name='check'
								className='bg-white rounded mr-2 text-sm'
								onChange={formik.handleChange}
							/>
							By ticking this box, you agree to the{' '}
							<Link
								to='/terms-and-conditions'
								target='_blank'
								rel='noopener noreferrer'
								className='text-purple mr-2'
							>
								terms and conditions
							</Link>
							of our organization <b className='text-red text-base'>*</b>
						</label>
						{formik.touched.check && formik.errors.check ? (
							<div className='text-red text-base'>{formik.errors.check}</div>
						) : null}
					</div>

					<div className='grid sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 pb-4'>
						<div></div>
						<div className='flex justify-center'>
							<button
								type='submit'
								className='w-32 h-12 text-base bg-purple text-white rounded'
							>
								Submit
							</button>
						</div>
						<div></div>
					</div>
				</form>
			</div>
		</>
	);
}

export default PartnerWithUsIndividual;
